var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.chartOptions)?_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"chart-title"},[_vm._v("Produto por Formato")]),_c('apexcharts',{attrs:{"type":"heatmap","height":"550","options":_vm.chartOptions,"series":_vm.chartSeries}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }